import React from "react";
import Typography from "@material-ui/core/Typography";
const UserGroup = ({}) => {
  return (
    <React.Fragment>
      <Typography paragraph variant="h4">
        User Group
      </Typography>
      <Typography paragraph variant="h5">
        Manage user group master data for every roles in company
      </Typography>
      <Typography paragraph variant="body1">
        User Group is one of the features under the User module to manage the
        user group master data to define any user roles which suitable for the
        company. It contains any information regarding the user group or role
        and user group authorization assignment. Later, this user group will be
        assigned to the user.
      </Typography>
      <Typography paragraph variant="h5" className="mt-5">
        How it works
      </Typography>
      <Typography paragraph variant="body1">
        The first information displayed on this feature is the User Group list.
        It is displayed like a table that contains download functions, sort,
        filter, and global search on the header area, and contains data
        navigation and refresh function on the footer area. The data column that
        appears in this table list are listed below:
      </Typography>
      <Typography paragraph variant="body1">
        <b>User Group ID</b>
        <br />
        Indicates the ID of the User Group or Role.
      </Typography>
      <Typography paragraph variant="body1">
        <b>User Group Name</b>
        <br />
        Indicates the name of the User Group or Role.
      </Typography>
      <Typography paragraph variant="body1">
        <b>Authorization</b>
        <br />
        Indicates the authorization assignment of the User Group or Role.
      </Typography>
      <Typography paragraph variant="body1">
        <b>Sales Group</b>
        <br />
        Indicates whether the User Group or Role is related to the sales
        activity or not.
      </Typography>
      <Typography paragraph variant="body1">
        Apart from the column appearing on the table list, there are more
        columns available on each row by clicking the expand button on the left
        side of each data.
      </Typography>
      <Typography paragraph variant="body1">
        Besides, there are 2 buttons that appear on each row of User Group data
        with specific conditions explained below:
      </Typography>
      <Typography paragraph variant="body1">
        <b>Edit User Group</b>
        <br />
        This button is used to edit the User Group data. Any records that have
        the 'Standard record protection' icon are unable to be edited.
      </Typography>
      <Typography paragraph variant="body1">
        <b>Delete User Group</b>
        <br />
        This button is used to delete the User Group data. Any records that have
        the 'Standard record protection' icon are unable to be deleted.
      </Typography>
    </React.Fragment>
  );
};

export default UserGroup;
